export default class Observer {
  constructor(selector, margin, conf, cb) {
    let observablesSelector = selector || '.observe';
    const observables = document.querySelectorAll(observablesSelector);

    if (!window.IntersectionObserver) {
      console.warn('IntersectionObserver not supported');
      for (let el of observables) {
        cb(el);
      }
    } else {
      console.debug('IntersectionObserver supported');
      const rootMargin = margin || Math.floor(window.outerHeight / 3);
      const observer = new IntersectionObserver(cb, conf || {
        root: null,
        rootMargin: `${rootMargin}px 0px`,
        threshold: 0.0
      });

      for (let observable of observables) {
        observer.observe(observable);
      }
    }
  }
}